
import { instantiate } from './sampleCompose.uninstantiated.mjs';
export default (await instantiate()).exports;
